export default "__VITE_ASSET__DpxWIuSU__$_?component__"